import { render, staticRenderFns } from "./addRadiografieModal.vue?vue&type=template&id=1bd19bed"
import script from "./addRadiografieModal.vue?vue&type=script&lang=js"
export * from "./addRadiografieModal.vue?vue&type=script&lang=js"
import style0 from "./addRadiografieModal.vue?vue&type=style&index=0&id=1bd19bed&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports